import React from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Translate } from '@hydra/common/components';
import { useReviewContext } from '@hydra/common/context';

const useStyles = makeStyles(theme => ({
  spacingLarge: {
    paddingTop: theme.spacing(10),
    marginTop: theme.spacing(-6)
  },
  spacingSmall: {
    paddingTop: theme.spacing(2)
  }
}));

const ReviewSection = ({ section, children, className }) => {
  const classes = useStyles();
  const { isPdf, isAssistant } = useReviewContext();

  return (
    <div className={className}>
      {!isPdf && (
        <Typography
          variant='h2'
          color='textPrimary'
          className={isAssistant ? classes.spacingSmall : classes.spacingLarge}
          id={`module-section-title-${section}`}
        >
          <Translate content={`wip_section_${section}`} />
        </Typography>
      )}
      {children}
    </div>
  );
};

export default React.memo(ReviewSection);
